import {
  PiCalendarCheckLight,
  PiUserPlusLight,
  PiUsersLight,
  PiCurrencyGbpLight,
} from "react-icons/pi";
import { ICON_SIZE } from ".";
import { PAGE_ROUTES } from "./page-routes";

export const ADMIN_DASHBOARD_TILES_METADATA: WidgetMetadata[] = [
  {
    icon: <PiCalendarCheckLight size={ICON_SIZE} />,
    path: PAGE_ROUTES.ADMIN.DashboardAppointments,
  },
  {
    icon: <PiUserPlusLight size={ICON_SIZE} />,
    path: PAGE_ROUTES.ADMIN.DashboardSubscription,
  },
  {
    icon: <PiUsersLight size={ICON_SIZE} />,
    path: PAGE_ROUTES.ADMIN.DashboardOccupancy,
  },
  {
    icon: <PiCurrencyGbpLight size={ICON_SIZE} />,
  },
];

export const PRACTITIONER_PROFILE_TABS = [
  { id: 0, label: "General" },
  { id: 1, label: "Therapies" },
  //{ id: 2, label: "Highlights" },
  { id: 2, label: "Attachments" },
] as GeneralItem[];

export const PATIENT_PROFILE_TABS = [
  { id: 0, label: "General" },
] as GeneralItem[];
